module.exports = __webpack_public_path__ + "img/logo.f521b0a8.png";